import PropTypes from 'prop-types';
import React, {Component} from 'react';
import {SVGIcon} from '@homeaway/react-svg';

/**
 * DropdownItem
 *
 */
class DropdownItem extends Component {
    static propTypes = {
        /** Flag for if <a> tag needs a data-bypass attribute; for use in legacy ThinSPA apps */
        dataBypass: PropTypes.bool,
        /** URL of the DropdownItem.*/
        link: PropTypes.string,
        /** Text (or markup) to display on the DropdownItem. */
        text: PropTypes.node,
        /** For direct imports, use the SVG markup from @homeaway/svg-defs module */
        svgMarkup: PropTypes.string,
        /** ID name of SVG from an SVG Definition block, the xlink:href of the SVG you want. Used in the 'use' tag to grab it's definition from the SVG Definitions */
        svgId: PropTypes.string
    }

    static defaultProps = {
        dataBypass: false
    }

    constructor(props) {
        super(props);
    }

    render() {
        const {link, dataBypass, text, svgMarkup, svgId, ...rest} = this.props;
        let finalIconMarkup;

        if (svgMarkup) {
            finalIconMarkup = <SVGIcon inlineFlex className="icon-color" markup={svgMarkup}/>;
        } else if (svgId) {
            finalIconMarkup = <SVGIcon inlineFlex className="icon-color" id={svgId}/>;
        }

        if (link) {
            return (<li {...rest}><a data-bypass={dataBypass} href={link}>{finalIconMarkup} {text}</a></li>);
        }

        return (
            <li {...rest}>{text}</li>
        );
    }
}

export default DropdownItem;
